// React
import React, { Component } from "react";
import PropTypes from "prop-types";

// Redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

// Libs
import { Row, Col } from "react-bootstrap";

// Components
import SalesBreakdown from "./SalesBreakdown";
import Container from "../../component/Container";
import { ListGroupSpocket, ListGroupItemSpocket } from "shared_components";

// Module
import { getSalesAnalysis } from "../../module/analytics/salesAnalysis";

// Utils
import { snakeCaseToPascalCase } from "../../utils/string";

// Style
import "./SalesTab.css";

class SalesTab extends Component {
  render() {
    const {
      orders,
      breakdown,
      getSalesAnalysis,
      startDate,
      endDate,
      orderStatus
    } = this.props;

    return (
      <Row className="mt-30">
        <Col md={4}>
          <ListGroupSpocket style={{ padding: "0" }}>
            {Object.keys(orders).map((order, index) => {
              return (
                <ListGroupItemSpocket
                  theme="line"
                  key={index}
                  name={order}
                  className={`sales-tab__order-line
                  ${orderStatus === order && "sales-tab__order-line-selected"}`}
                  onClick={e => {
                    getSalesAnalysis(startDate, endDate, e.target.name);
                  }}
                >
                  <span>{snakeCaseToPascalCase(order)}</span>
                  <span>{orders[order]}</span>
                </ListGroupItemSpocket>
              );
            })}
          </ListGroupSpocket>
        </Col>
        <Col md={8}>
          <Container>
            <div>
              <h1>Sales Breakdown</h1>
              <SalesBreakdown breakdown={breakdown} />
            </div>
          </Container>
        </Col>
      </Row>
    );
  }
}

SalesTab.propTypes = {
  orders: PropTypes.object.isRequired,
  breakdown: PropTypes.array.isRequired
};

function mapStateToProps(state) {
  return {
    startDate: state.analytics.salesAnalysis.startDate,
    endDate: state.analytics.salesAnalysis.endDate,
    orderStatus: state.analytics.salesAnalysis.orderStatus
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ getSalesAnalysis }, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SalesTab);



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/financialDashboard/SalesTab.js